import * as z from "zod/v4";

export const MINIMUM_LAST_YEAR_ORDER_COUNT = 7000;

const successOutput = z.object({
  success: z.literal(true),
  lastThirtyDaysCount: z.number(),
  lastYearCount: z.number(),
});

const failureOutput = z.object({
  success: z.literal(false),
});

export const getOnlineStoreOrderCounts = {
  name: "getOnlineStoreOrderCounts" as const,
  input: z.void(),
  output: z.discriminatedUnion("success", [successOutput, failureOutput]),
};
